import React, { useEffect, useState } from 'react';
import axios from 'axios';

const MySendingRank = ({ myId }) => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [month, setMonth] = useState(new Date().getMonth());
    const [uniqueId, setUniqueId] = useState('');
    const [searchId, setSearchId] = useState('');
    const [totalCoins, setTotalCoins] = useState(0);
    const [myRank, setMyRank] = useState(null);

    const fetchData = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BASEURL5}/admin/coinPanel/coinPanelSendingRanking`, {
                params: {
                    page,
                    limit,
                    uniqueId: searchId || undefined,
                    month
                }
            });
            if (res.data.success) {
                setData(res.data.details);
                setTotalPages(Math.ceil(res.data.details.length < limit ? page : page + 1));
                setTotalCoins(res.data.totalCoins || 0);

                const fullListRes = await axios.get(`${process.env.REACT_APP_BASEURL5}/admin/coinPanel/coinPanelSendingRanking`, {
                    params: {
                        page: 1,
                        limit: 1000,
                        month
                    }
                });
                if (fullListRes.data.success) {
                    const fullList = fullListRes.data.details;
                    const rank = fullList.findIndex(entry => entry.unqiueId === myId);
                    setMyRank(rank >= 0 ? rank + 1 : null);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [page, month, searchId]);

    const months = Array.from({ length: 6 }, (_, i) => {
        const d = new Date();
        d.setMonth(d.getMonth() - i);
        return { label: d.toLocaleString('default', { month: 'long' }), index: d.getMonth() };
    }).reverse();

    const handleSearch = () => {
        setPage(1);
        setSearchId(uniqueId);
    };

    return (
        <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Coin Panel Monthly Ranking</h1>

            {myRank && (
                <div style={{
                    backgroundColor: '#d1fae5',
                    padding: '1rem',
                    marginBottom: '1rem',
                    borderRadius: '6px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    animation: 'fadeIn 2s ease-in-out'
                }}>
                    🎉 Congratulations! You are in the top {myRank}!
                </div>
            )}

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginBottom: '1rem' }}>

            </div>

         

            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
                <thead>
                    <tr style={{ backgroundColor: '#f3f4f6' }}>
                        <th style={{ border: '1px solid #ddd', padding: '0.5rem' }}>Rank</th>
                        <th style={{ border: '1px solid #ddd', padding: '0.5rem' }}>Image</th>
                        <th style={{ border: '1px solid #ddd', padding: '0.5rem' }}>Name</th>
                        <th style={{ border: '1px solid #ddd', padding: '0.5rem' }}>Unique ID</th>
                        <th style={{ border: '1px solid #ddd', padding: '0.5rem' }}>Coins</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((entry, index) => (
                        <tr
                            key={index}
                            style={{
                                backgroundColor: entry.unqiueId == myId ? '#fef08a' : 'transparent'
                            }}
                        >
                            <td style={{ border: '1px solid #ddd', padding: '0.5rem', textAlign: 'center' }}>{(page - 1) * limit + index + 1}</td>
                            <td style={{ border: '1px solid #ddd', padding: '0.5rem' }}>                    <img src={`${entry?.image}`} alt="" height={"40px"} width={"40px"} style={{ borderRadius: "100%" }} />
                            </td>
                            <td style={{ border: '1px solid #ddd', padding: '0.5rem' }}>{entry?.name}</td>
                            <td style={{ border: '1px solid #ddd', padding: '0.5rem' }}>{entry.unqiueId}</td>
                            <td style={{ border: '1px solid #ddd', padding: '0.5rem' }}>{entry.coins}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1rem' }}>
                <button
                    onClick={() => setPage(p => Math.max(p - 1, 1))}
                    disabled={page === 1}
                    style={{ backgroundColor: '#e5e7eb', padding: '0.5rem 1rem', borderRadius: '4px', opacity: page === 1 ? 0.5 : 1 }}
                >
                    Prev
                </button>

                <span>Page {page}</span>

                <button
                    onClick={() => setPage(p => p + 1)}
                    disabled={data.length < limit}
                    style={{ backgroundColor: '#e5e7eb', padding: '0.5rem 1rem', borderRadius: '4px', opacity: data.length < limit ? 0.5 : 1 }}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default MySendingRank;